<template :title="pageTitle">
  <layout>
    <div class="box">
      <a id="overview"></a>
      <div class="title-bar">
        <h3>Email Dates</h3>
      </div>
      <hr style="margin-top: 15px" />
      <div class="columns">
        <div class="column">
          <b-field label="Welcome Date">
            <b-datepicker
              v-model="settingsForm.welcomeDate"
              :show-week-number="showWeekNumber"
              :locale="locale"
              @input="submitSettings"
              placeholder="Click to select..."
              trap-focus
            >
            </b-datepicker>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Chase Date">
            <b-datepicker
              v-model="settingsForm.chaseDate"
              :show-week-number="showWeekNumber"
              :min-date="settingsForm.welcomeDate"
              :locale="locale"
              @input="submitSettings"
              placeholder="Click to select..."
              trap-focus
            >
            </b-datepicker>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="2nd Chase Date">
            <b-datepicker
              v-model="settingsForm.secondChaseDate"
              :show-week-number="showWeekNumber"
              :min-date="settingsForm.chaseDate"
              :locale="locale"
              @input="submitSettings"
              placeholder="Click to select..."
              trap-focus
            >
            </b-datepicker>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Deadline Extension Date">
            <b-datepicker
              v-model="settingsForm.deadlineExtensionDate"
              :show-week-number="showWeekNumber"
              :min-date="settingsForm.secondChaseDate"
              :locale="locale"
              @input="submitSettings"
              placeholder="Click to select..."
              trap-focus
            >
            </b-datepicker>
          </b-field>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-justify-content-flex-end">
        <inertia-link
          :href="route('projects.setup.relationships', project.unique_id)"
        >
          <b-button class="button is-primary"> Next </b-button>
        </inertia-link>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '../Layout';

export default {
  components: {
    Layout,
  },
  props: {
    project: { type: Object },
    settings: { type: Object },
  },
  data() {
    let softDate = transformDate(this.project.soft_end_date);
    let welcomeDate = transformDate(this.settings.welcomeDate.value);
    let chaseDate = transformDate(this.settings.chaseDate.value);
    let secondChaseDate = transformDate(this.settings.secondChaseDate.value);
    let deadlineExtensionDate = transformDate(
      this.settings.deadlineExtensionDate.value
    );

    return {
      pageTitle: 'Edit Email Dates: ' + this.project.name,
      settingsForm: {
        welcomeDate,
        chaseDate,
        secondChaseDate,
        deadlineExtensionDate,
      },
      form: {
        soft_end_date: softDate,
        isSending: false,
      },
      showWeekNumber: false,
      locale: 'en-GB',
    };
  },
  methods: {
    submitSettings() {
      const data = {
        welcomeDate:
          this.settingsForm.welcomeDate?.toISOString().slice(0, 10) ?? null,
        chaseDate:
          this.settingsForm.chaseDate?.toISOString().slice(0, 10) ?? null,
        secondChaseDate:
          this.settingsForm.secondChaseDate?.toISOString().slice(0, 10) ?? null,
        deadlineExtensionDate:
          this.settingsForm.deadlineExtensionDate?.toISOString().slice(0, 10) ??
          null,
      };
      this.$inertia.patch(
        route('projects.updateSettings', this.project.unique_id),
        data,
        {
          onStart: () => (this.form.isSending = true),
          onFinish: () => {
            this.$buefy.toast.open({
              message: 'Project information updated',
              type: 'is-success',
              position: 'is-top',
            });
            this.form.isSending = false;
          },
          onError: () => {},
        }
      );
    },
  },
};

function transformDate(date) {
  if (!date) {
    return null;
  }

  return new Date(date);
}
</script>
